import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Divider } from "semantic-ui-react";
import LoadResolver from "components/LoadResolver";
import { toast } from "../Toast/Toast";
import { DigitalServiceForm } from "forms/DigitalService";
import { getAgencys, getUsers } from "store/selectors";
import { AgencyType } from "models";
import { DigitalServiceTable } from "../DigitalServiceTable/DigitalServiceTable";

export const DigitalServiceEditor = ({ dispatch, t }) => {
  const [isDigitalServiceFormOpen, setIsDigitalServiceFormOpen] = useState(false);
  const [digitalServiceToUpdate, setDigitalServiceToUpdate] = useState(null);

  useEffect(() => {
    dispatch.agencys.load(AgencyType.DIGITAL_SERVICE);
    dispatch.users.init();
  }, []);

  const agencys = useSelector(getAgencys);
  const users = useSelector(getUsers);

  const handleDigitalServiceFormClose = () => {
    setIsDigitalServiceFormOpen(false);
    setDigitalServiceToUpdate(null);
  };

  const handleUpdate = (digitalServiceToUpdate) => {
    setDigitalServiceToUpdate(digitalServiceToUpdate);
    setIsDigitalServiceFormOpen(true);
  };

  const handleDelete = async (digitalServiceToDelete) => {
    try {
      await dispatch.agencys.delete(digitalServiceToDelete.id);
      toast(undefined, t("digital_service_delete_success"));
    } catch (error) {
      console.error(error);
      toast("error", t("digital_service_delete_failure"));
    }
  };

  return (
    <LoadResolver
      isLoading={agencys.isLoading || users.isLoading}
      error={agencys.error || users.error}
    >
      <div className="page-container">
        <h2>{t("digital_services")}</h2>
        {isDigitalServiceFormOpen ? (
          <DigitalServiceForm
            digitalServiceToUpdate={digitalServiceToUpdate}
            closeDigitalServiceForm={handleDigitalServiceFormClose}
            users={users.items}
            dispatch={dispatch}
            t={t}
          />
        ) : (
          <>
            <Button primary onClick={() => setIsDigitalServiceFormOpen(true)}>
              {t("create_new")}
            </Button>
            <Divider />
            <DigitalServiceTable
              items={agencys.items}
              users={users.items}
              setDigitalServiceToUpdate={setDigitalServiceToUpdate}
              handleUpdate={handleUpdate}
              handleDelete={handleDelete}
              t={t}
            />
          </>
        )}
      </div>
    </LoadResolver>
  );
};
